/**
 * The project's CLIENT among its association rows, picked the one way every surface and the server agree on.
 *
 * A project association row is a contact (type 1), the client company (type 2) or the client person (type 3).
 * `Vf_Get_Project_Association` lists the rows in no set order (contacts can come before a person client), and some
 * projects carry more than one client row (legacy duplicates, `PROJECT_CLIENT_ASSOCIATION_REPAIR_PLAN.md`). So the
 * client is the type 2/3 row with the LOWEST `proAssoId`: never a contact, and null when there is none.
 *
 * The server's `getUpdatedProject` Client event picks it the same way (`TaskAppService.ProjectClientOf`), so the panel
 * that made a change and every other open screen show the same client. Cases U1-U6 of
 * `PROJECT_CLIENT_DELETE_EVENT_TEST_CASES.md` (round 3).
 */

/**
 * The shape needed from an association row. Structural, so the `ProjectAssociationDto` proxy class and the panels'
 * normalized copies of it both fit without a cast.
 */
export interface ProjectAssociationLike {
    proAssoId?: number | undefined;
    associationType?: number | undefined;
}

/** `ProjectAssociationType` values that make a row the project's client: company (2) or person (3). */
const CLIENT_ASSOCIATION_TYPES: ReadonlyArray<number> = [2, 3];

export function projectClientOf<T extends ProjectAssociationLike>(
    associations: ReadonlyArray<T | null | undefined> | null | undefined
): T | null {
    let client: T | null = null;
    for (const row of associations || []) {
        if (!row || CLIENT_ASSOCIATION_TYPES.indexOf(Number(row.associationType)) === -1) {
            continue;
        }
        if (client === null || Number(row.proAssoId) < Number(client.proAssoId)) {
            client = row;
        }
    }
    return client;
}
